import { Injectable } from '@angular/core';
import { Layer } from 'src/app/modules/cop/store/cop/models';
import { LayerDataChangeEvent, LayerDataChangeType } from 'src/app/modules/cop/store/cop/models/layer-data-change-event.model';
import { Document, FieldDataType } from '../../core/store/models/document.model';
import { Dataset } from '../../core/store/models/dataset.model';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SiteWatchOfficerService {
  officerLayer: Layer;
  officerLayerDataset: Dataset;

  officerSubject$ = new Subject<any>();

  constructor() {}

  handleOfficerEvent(e: LayerDataChangeEvent) {
    const documents = Object.values(e.changes);
    const schema = this.officerLayerDataset?.schema;
    const firstGeoFieldName = schema.fields.find(f => f.dataType === FieldDataType.Geometry)?.systemName;
    const geoSourceFieldName = this.officerLayer.displayOptions?.geoJsonSourceField ?? firstGeoFieldName;

    const updatedDocSet = {};

    documents.forEach(d => {
      let updatedDoc = {
        ...d,
        _layer: this.officerLayer,
        _geometryFieldName: geoSourceFieldName
      };

      updatedDocSet[d.uid] = updatedDoc;
    });

    const updatedEvent = {
      ...e,
      changes: updatedDocSet,
      geoSourceFieldName,
      layer: this.officerLayer
    };

    this.officerSubject$.next(updatedEvent);
  }

  clearService() {
    this.officerLayer = null;
    this.officerLayerDataset = null;
    this.officerSubject$.next(null);
  }
}
